import { Header, Link, List, ListItem, Text } from '@bbl-digital/snorre'
import { Button } from '@bbl-digital/snorre-v2'
import { FCWithChildren } from 'global'
import { Fragment, useEffect, useState } from 'react'
import {
  browserVersion,
  isChrome,
  isEdgeChromium,
  isSafari,
} from 'react-device-detect'
import OverlayWithComposition from 'shared/components/OverlayWithComposistion'
import { LOCAL_STORAGE_UNSUPPORTED_BROWSER_CONTINUE } from 'shared/constants/localStorageVariables'
import { ContinueGroup, Wrapper } from './styles'

const BrowserSupport: FCWithChildren = ({ children }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (window.ReactNativeWebView) {
      return setShow(false)
    }

    if (isChrome && parseInt(browserVersion) > 86) {
      return setShow(false)
    }
    if (isSafari && parseInt(browserVersion) > 12) {
      return setShow(false)
    }
    if (isEdgeChromium && parseInt(browserVersion) > 86) {
      return setShow(false)
    }
    if (
      localStorage.getItem(LOCAL_STORAGE_UNSUPPORTED_BROWSER_CONTINUE) ===
      'true'
    ) {
      return setShow(false)
    }

    setShow(true)
  }, [])

  const ignore = () => {
    localStorage.setItem(LOCAL_STORAGE_UNSUPPORTED_BROWSER_CONTINUE, 'true')
    setShow(false)
  }

  const Unsupportedview = (
    <OverlayWithComposition>
      <Wrapper>
        <Header level={3}>Din nettleser</Header>
        <Text paragraph align="center">
          Ved bruk av nettsiden anbefaler vi at du benytter en nyere versjon av
          nettleserne vi støtter. Ved bruk av andre nettlesere, kan vi ikke
          garantere at du ikke vil oppleve feil knyttet til utseende og
          funksjonalitet.
        </Text>
        <Text>Vi støtter følgende nettlesere:</Text>
        <List links>
          <ListItem>
            <Link href="https://www.google.com/chrome/" target="_blank">
              Google Chrome (versjon 87+)
            </Link>
          </ListItem>
          <ListItem>
            <Link href="https://www.microsoft.com/en-us/edge" target="_blank">
              Microsoft Edge (versjon 87+)
            </Link>
          </ListItem>
          <ListItem>
            <Link
              href="https://support.apple.com/downloads/safari"
              target="_blank"
            >
              Safari (versjon 13+)
            </Link>
          </ListItem>
        </List>
        <ContinueGroup>
          <Button
            variant="danger"
            small
            onClick={ignore}
            trackingName="Felles"
            trackingEvent="Ikke støttet browser: Ignorer"
          >
            Fortsett
          </Button>
          <Text subtle size="12px" align="center">
            Fortsett med forbehold om at visse funksjoner ikke fungerer optimalt
          </Text>
        </ContinueGroup>
      </Wrapper>
    </OverlayWithComposition>
  )

  return <Fragment>{show ? Unsupportedview : children}</Fragment>
}

export default BrowserSupport
